module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/ethdetail-cf6f6da6a26ae2c6ebd1fbcc594792ab.png";